export default "__VITE_ASSET__Dantiqcg__"